import React from 'react';
import  Map  from './ui/MapComponent';

const CustomComponents = () => {
  return (
    <>
      <Map />
      {/*  <section>
        <div className="text-display">Hello</div>
        <h1>
          Είστε σίγουροι πως θέλετε να αφαιρέσετε τον χρήστη test test από οδηγό
          του οχήματος με πινακίδα YTT5615; Η ενέργεια αυτή δεν μπορεί να
          αναιρεθεί.
        </h1>
        <h2>
          Είστε σίγουροι πως θέλετε να αφαιρέσετε τον χρήστη test test από οδηγό
          του οχήματος με πινακίδα YTT5615; Η ενέργεια αυτή δεν μπορεί να
          αναιρεθεί.
        </h2>
        <h3>
          Είστε σίγουροι πως θέλετε να αφαιρέσετε τον χρήστη test test από οδηγό
          του οχήματος με πινακίδα YTT5615; Η ενέργεια αυτή δεν μπορεί να
          αναιρεθεί. H3
        </h3>
        <h4>
          Είστε σίγουροι πως θέλετε να αφαιρέσετε τον χρήστη test test από οδηγό
          του οχήματος με πινακίδα YTT5615; Η ενέργεια αυτή δεν μπορεί να
          αναιρεθεί. H4
        </h4>
        <h5>
          Είστε σίγουροι πως θέλετε να αφαιρέσετε τον χρήστη test test από οδηγό
          του οχήματος με πινακίδα YTT5615; Η ενέργεια αυτή δεν μπορεί να
          αναιρεθεί. H5
        </h5>
        <h6>
          Είστε σίγουροι πως θέλετε να αφαιρέσετε τον χρήστη test test από οδηγό
          του οχήματος με πινακίδα YTT5615; Η ενέργεια αυτή δεν μπορεί να
          αναιρεθεί. H6
        </h6>
        <span className="text-subtitle">Subtitle</span>
        <p className="text-label">
          Είστε σίγουροι πως θέλετε να αφαιρέσετε τον χρήστη test test από οδηγό
          του οχήματος με πινακίδα YTT5615; Η ενέργεια αυτή δεν μπορεί να
          αναιρεθεί.
        </p>
        <p className="text-link">
          Είστε σίγουροι πως θέλετε να αφαιρέσετε τον χρήστη test test από οδηγό
          του οχήματος με πινακίδα YTT5615; Η ενέργεια αυτή δεν μπορεί να
          αναιρεθεί.
        </p>
        <p className="text-subtitle">
          Είστε σίγουροι πως θέλετε να αφαιρέσετε τον χρήστη test test από οδηγό
          του οχήματος με πινακίδα YTT5615; Η ενέργεια αυτή δεν μπορεί να
          αναιρεθεί.
        </p>
        <button className="text-primary-button ">
          Είστε σίγουροι πως θέλετε να αφαιρέσετε
        </button>
        <div className="text-label">text-labelUserName</div>
        <div className="text-disclaimer">Lorem ipsum dolor sit amet.</div>
      </section>
      <section className="pt-5">
        <button type="button" className="btn-primary m-4">
          Primary Button
        </button>
        <button type="button" className="btn-primary m-4" disabled>
          Primary Button Disabled
        </button>
        <button type="button" className="btn-secondary m-4">
          Secondary Button
        </button>
        <button type="button" className="btn-secondary m-4" disabled>
          Secondary Button Disabled
        </button>
        <br></br>
        <button type="button" className="btn-tertiary">
          Tertiary Button
        </button>
        <button type="button" className="btn-tertiary" disabled>
          Tertiary Button
        </button>
        <br />
        <a href="#" className="btn-nav-link">
          Link
        </a>
        <button role="navigation" className="btn-nav-link">
          Link
        </button>
      </section> */}

      <p className="text-powdergrey">
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Tempore iusto
        expedita dolorum, excepturi perspiciatis fugit distinctio id molestias
        illum adipisci unde harum dicta natus, alias accusamus autem minima
        voluptates fuga.
      </p>
      <p className="text-primary">
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Tempore iusto
        expedita dolorum, excepturi perspiciatis fugit distinctio id molestias
        illum adipisci unde harum dicta natus, alias accusamus autem minima
        voluptates fuga.
      </p>
      <p className="text-fadedgrey">
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Tempore iusto
        expedita dolorum, excepturi perspiciatis fugit distinctio id molestias
        illum adipisci unde harum dicta natus, alias accusamus autem minima
        voluptates fuga.
      </p>

      <div className="bg-primary">hfdkfj</div>
      <div className="bg-mildgrey">hfdkfj</div>
    </>
  );
};

export default CustomComponents;
